import React, { PropsWithChildren, ReactElement } from 'react';
import { useAppSelector } from '../../app/hooks';
import { isInGroup } from './authSlice';

export type AuthFlagProps = {
    authGroup: string | string[],
    fallback?: ReactElement
}

const AuthFlag: React.FC<PropsWithChildren<AuthFlagProps>> = ({children, authGroup, fallback}) => {
    const authGroups: string[] = !!Array.isArray(authGroup) ? authGroup : [authGroup];
    
    const hasPermissions = useAppSelector(isInGroup(authGroups));


    return hasPermissions ? <>{children}</> : (fallback || null)
}

export default AuthFlag;